import {Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField, useTheme} from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHasScope } from "../../../../config/globalConfig";
import { vehicleActions } from "../../service/vehicle.actions";
import GenericFilterBox from "../common/GenericFilterBox";
import "./Vehicle.css";
import FormInput from "../common/FormInput";
import { AutoCompleteOption } from "../common/AutoComplete";

const FiltersModal = (props: any) => {
  const theme = useTheme();
  const hasScope: any = useHasScope;
  const {filtersToParent, data, setData, filter, setFilter, cancel, resetPower, tenant} = props;

  const action = vehicleActions();
  const [brand, setBrand] = useState<any>([]);
  const [model, setModel] = useState<any>([]);
  const [carSegment, setCarSegment] = useState<any>([]);
  const [carClass, setCarClass] = useState<any>([]);
  const [tireType, setTireType] = useState<any>([]);
  const [sipp, setSipp] = useState<any>([]);
  const [acriss, setAcriss] = useState<any>([]);
  const [reasonCodes, setReasonCodes] = useState<AutoCompleteOption[]>([]);

  const ownershipOptions = ['DRIVALIA', 'NON DRIVALIA'];

  const { t } = useTranslation(["operation"]);
  const arrayVehicleStatus = [
    { id: "AVAILABLE", descr: t("internOptionSelectName.available") },
    { id: "NOT_AVAILABLE", descr: t("internOptionSelectName.notAvailable") },
  ];
  const arrayInFleet = [
    { id: null, descr: t("vehicle.all") },
    { id: "true", descr: t("internOptionSelectName.yes") },
    { id: "false", descr: t("internOptionSelectName.no") },
  ];

  const arrayFirstFueling = [
    { id: "true", descr: t("internOptionSelectName.yes") },
    { id: "false", descr: t("internOptionSelectName.no") },
  ];

  async function getFilters() {
    action.getBrands(tenant).then((b: any) => setBrand(b.data));
    action.getModels(tenant).then((m: any) => setModel(m.data));
    action.getCarSegment(tenant).then((s: any) => setCarSegment(s.data));
    action.getCarClass(tenant).then((c: any) => setCarClass(c.data));
    action.getAllTireType().then((c: any) => setTireType(c.data));
    action.getSipp(tenant).then((response) => setSipp(response));
    action.getAcriss(tenant).then((response) => setAcriss(response));

    action.getReasonCodes(tenant).then((response) => setReasonCodes(response.map(element => ({
      value: element.code,
      label: `${element.code} - ${element.descr}`,
    }))));
  }

  useEffect(() => {
    getFilters();
  }, [tenant]);

  const handleChangeBrand = (event: any, type: any) => {
    setData({
      ...data,
      [type]: {
        ...data?.[type],
        id: event?.id ? event?.id : "",
        descr: event?.descr ? event?.descr : "",
      },
    });
  };
  const handleChangeTire = (event: any, type: any) => {
    setData({
      ...data,
      [type]: {
        ...data?.[type],
        code: event?.code ? event?.code : "",
        description: event?.description ? event?.description : "",
      },
    });
  };

  const handleOwnership = (event: any, type: any) => {

    console.log(JSON.stringify(event))
    setData({ ...data, [type]: event });
  };


  const handleChange = (event: any, type: any) => {
    setData({ ...data, [type]: event.target.value });
  };
  filtersToParent(data);

  const onSearch = (e: any) => {
    e.preventDefault();
    setFilter(!filter);
  };

  const enginePowerGroupCodes = [
    { label: t("vehicle.enginePowerGroupCodes.termicDiesel"), value: "D" },
    { label: t("vehicle.enginePowerGroupCodes.electric"), value: "E" },
    { label: t("vehicle.enginePowerGroupCodes.termicLPG"), value: "G" },
    { label: t("vehicle.enginePowerGroupCodes.termicGasoline"), value: "B" },
    { label: t("vehicle.enginePowerGroupCodes.hybridGasoline"), value: "HB" },
    { label: t("vehicle.enginePowerGroupCodes.hybridDiesel"), value: "HD" },
  ];

  const filteredModels = (data.brand.id ? model.filter((c: any) => c.brand.id === data.brand.id) : model);
 
  const filteredClass = (data.carSegment.id ? carClass.filter((c: any) => c.carSegment.id === data.carSegment.id) : carClass);
  const filteredAcriss = (data.carClass.id ? acriss?.filter((element: any) => element?.carClass?.id === data.carClass.id) : acriss);
  const filteredSipp = (data.carAcriss.id ? sipp?.filter((element: any) => element?.acriss?.id === data.carAcriss.id) : sipp);


  useMemo(() => {
    if (
      (data.carSegment.id === "" || data.carSegment.id) &&
      data.carClass.id !== ""
    ) {
      setData({
        ...data,
        carClass: {
          id: "",
          descr: "",
        },
        carAcriss: {
          id: "",
          code: "",
        },
        carSipp: {
          id: "",
          code: "",
        },
      });
    }
  }, [data.carSegment]);

  useMemo(() => {
    if (
      (data.carClass.id === "" || data.carClass.id) &&
      data.carAcriss.id !== ""
    ) {
      setData({
        ...data,
        carAcriss: {
          id: "",
          code: "",
        },
        carSipp: {
          id: "",
          code: "",
        },
      });
    }
  }, [data.carClass]);

  useMemo(() => {
    //console.log(data.brand, "data brand");
    setData({
      ...data,
      model: {
        id: "",
        descr: "",
      },
    });
  }, [data.brand]);

  useMemo(() => {
    if (
      (data.carAcriss.id === "" || data.carAcriss.id) &&
      data.carSipp.id !== ""
    ) {
      setData({
        ...data,
        carSipp: {
          id: "",
          code: "",
        },
      });
    }
  }, [data.carAcriss]);

  return (
    <Box>
      <form id="idVehicleMasterData" onSubmit={(e) => onSearch(e)}>
        <GenericFilterBox
          formId="idVehicleMasterData"
          onReset={cancel}
          showExtrasFilters={true}
        >
          <Box>
            <TextField
              fullWidth
              id="plate"
              name="plate"
              label={t("carMaintenance.filterAndSearch.plate")}
              //placeholder={t("carMaintenance.filterAndSearch.plateInput")}
              value={data.plate.toUpperCase()}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
              onChange={(event: any) => handleChange(event, "plate")}
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              id="vin"
              name="vin"
              label={t("carMaintenance.filterAndSearch.vin")}
              //placeholder={t("carMaintenance.filterAndSearch.vinInput")}
              value={data.vin.toUpperCase()}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
              onChange={(event: any) => handleChange(event, "vin")}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.brand.id ? false : true}
              id="brand"
              value={{ id: data.brand.id, descr: data.brand.descr }}
              options={brand.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (data.brand.id !== value?.id) {
                  e.stopPropagation();
                  handleChangeBrand(value, "brand");
                }
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.brandField")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.model.id ? false : true}
              id="model"
              value={{ id: data.model.id, descr: data.model.descr }}
              options={filteredModels.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (data.brand.id !== value?.id) {
                  e.stopPropagation();
                  handleChangeBrand(value, "model");
                }
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.modelField")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.carSegment.id ? false : true}
              id="carSegment"
              value={{ id: data.carSegment.id, descr: data.carSegment.descr }}
              options={carSegment.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (data.carSegment.id !== value?.id)
                  handleChangeBrand(value, "carSegment");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectCarSegment")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.carClass.id ? false : true}
              id="model"
              value={{ id: data.carClass.id, descr: data.carClass.descr }}
              options={filteredClass.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                if (data.carClass.id !== value?.id)
                  handleChangeBrand(value, "carClass");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectCarClass")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.carAcriss.id ? false : true}
              id="carAcriss"
              value={{ id: data.carAcriss.id, code: data.carAcriss.code }}
              options={filteredAcriss}
              getOptionLabel={(option: any) => option?.code}
              onChange={(e, value) => {
                if (data.carAcriss.id !== value?.id)
                  setData({
                    ...data,
                    carAcriss: {
                      ...data?.carAcriss,
                      id: value?.id || "",
                      code: value?.code || "",
                    },
                  });
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectAcriss")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.carSipp.id ? false : true}
              id="carSipp"
              value={{ id: data.carSipp.id, code: data.carSipp.code }}
              options={filteredSipp}
              getOptionLabel={(option: any) => option?.code}
              onChange={(e, value) => {
                if (data.carSipp.id !== value?.id)
                  setData({
                    ...data,
                    carSipp: {
                      ...data?.carSipp,
                      id: value?.id || "",
                      code: value?.code || "",
                    },
                  });
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.selectSipp")}
                />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.vehicleStatus.id ? false : true}
              id="vehicleStatus"
              value={{
                id: data.vehicleStatus.id,
                descr: data.vehicleStatus.descr,
              }}
              options={arrayVehicleStatus.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                e.stopPropagation();
                handleChangeBrand(value, "vehicleStatus");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.vehicleStatus")}
                />
              )}
            />
          </Box>

          <FormInput
            type="select"
            options={reasonCodes}
            label={t("vehicle.filterModal.reasonCode")}
            value={data.reasonCode}
            onChange={(value) => setData({...data, reasonCode: value})}
            multiple={true}
          />

          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable
              id="inFleet"
              value={{ id: data.inFleet.id, descr: data.inFleet.descr }}
              options={arrayInFleet.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.descr}
              onChange={(e, value) => {
                e.stopPropagation();
                handleChangeBrand(value, "inFleet");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.descr}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.fleetField")}
                />
              )}
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              id="imeiPrimary"
              name="imeiPrimary"
              label={t("carMaintenance.filterAndSearch.imeiPrimary")}
              //placeholder={t("carMaintenance.filterAndSearch.plateInput")}
              value={data.imeiPrimary}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
              onChange={(event: any) => handleChange(event, "imeiPrimary")}
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              id="imeiSecondary"
              name="imeiSecondary"
              label={t("carMaintenance.filterAndSearch.imeiSecondary")}
              //placeholder={t("carMaintenance.filterAndSearch.plateInput")}
              value={data.imeiSecondary}
              inputProps={{
                pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
              onChange={(event: any) => handleChange(event, "imeiSecondary")}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={data.currentTireType.code ? false : true}
              id="currentTireType"
              value={{
                code: "data.currentTireType.code",
                description: data.currentTireType.description,
              }}
              options={tireType.map((response: any) => response)}
              getOptionLabel={(option: any) => option?.description}
              onChange={(e, value) => {
                e.stopPropagation();
                handleChangeTire(value, "currentTireType");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option.description}
                  </li>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.tabPanel1.currentTireType")}
                />
              )}
            />
          </Box>
          <Box>
            <DatePicker
              label={t("carMaintenance.filterAndSearch.expectSaleDateFrom")}
              value={data.expectedSaleDateFrom}
              onChange={(e: any) => {
                setData({
                  ...data,
                  expectedSaleDateFrom: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              // ampm={false}
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  name="expectSaleDateFrom"
                />
              )}
            />
          </Box>

          <Box>
            <DatePicker
              label={t("carMaintenance.filterAndSearch.expectSaleDateTo")}
              value={data.expectedSaleDateTo}
              onChange={(e: any) => {
                setData({
                  ...data,
                  expectedSaleDateTo: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              //
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  name="expectSaleDateTo"
                />
              )}
            />
          </Box>

          {hasScope("SCOPE_VIEW_MDVEHICLE_FIRSTFUELING") && (
            <Box>
              <Autocomplete
                disablePortal
                sx={{
                  "&.MuiAutocomplete-root": {
                    "& button[title='Clear']": {
                      visibility: "visible",
                    },
                  },
                }}
                disableClearable={data.firstFuelingDone.id ? false : true}
                id="firstFuelingDone"
                value={{
                  id: data.firstFuelingDone.id,
                  descr: data.firstFuelingDone.descr,
                }}
                options={arrayFirstFueling.map((response: any) => response)}
                getOptionLabel={(option: any) => option?.descr}
                onChange={(e, value) => {
                  e.stopPropagation();
                  handleChangeBrand(value, "firstFuelingDone");
                }}
                renderOption={(props, option, state) => {
                  return (
                    <li {...props} key={props.id}>
                      {option.descr}
                    </li>
                  );
                }}
                renderInput={(params: any) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    {...params}
                    label={t("vehicle.filterModal.firstFuelingDone")}
                  />
                )}
              />
            </Box>
          )}
          <Box>
            <Autocomplete
              //value={resetPower ? null : data.enginePowerGroupCodes.label}

              getOptionDisabled={(option: any) => {
                if (
                  data.enginePowerGroupCodes.length > 0 &&
                  data.enginePowerGroupCodes.some(
                    (day: any) => day.value === option.value
                  )
                ) {
                  return true;
                }
                return false;
              }}
              key={resetPower}
              onChange={(event, newValue) => {
                setData({
                  ...data,
                  enginePowerGroupCodes: resetPower ? [] : newValue,
                });
              }}
              multiple
              options={enginePowerGroupCodes}
              renderInput={(params) => (
                <TextField
                  //fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.enginePower")}
                />
              )}
            />
          </Box>

          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}              
              id="ownership"
              options={ownershipOptions}     
              value={data.ownership}             
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicle.filterModal.ownership")}
                />
              )}
              
              getOptionLabel={(option: any) => option}
              onChange={(e, value) => {
                  e.stopPropagation();
                  handleOwnership(value, "ownership");
              }}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {option}
                  </li>
                );
              }}
            />
          </Box>
          
          <Box>
            <TextField
              fullWidth
              id="extColor"
              name="extColor"
              label={t("vehicle.filterModal.extColor")}
              value={data.extColor}
              onChange={(event: any) => handleChange(event, "extColor")}
            />
          </Box>

          <Box>
            <DatePicker
              label={t("vehicle.filterModal.registrationDateFrom")}
              value={data.registrationDateFrom}
              onChange={(e: any) => {
                setData({
                  ...data,
                  registrationDateFrom: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  error={false}
                />
              )}
            />
          </Box>

          
          <Box>
            <DatePicker
              label={t("vehicle.filterModal.registrationDateTo")}
              value={data.registrationDateTo}
              onChange={(e: any) => {
                setData({
                  ...data,
                  registrationDateTo: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  error={false}
                />
              )}
            />
          </Box>

          
          <Box>
            <DatePicker
              label={t("vehicle.filterModal.realDeliveryDateFrom")}
              value={data.realDeliveryDateFrom}
              onChange={(e: any) => {
                setData({
                  ...data,
                  realDeliveryDateFrom: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  error={false}
                />
              )}
            />
          </Box>

          
          <Box>
            <DatePicker
              label={t("vehicle.filterModal.realDeliveryDateTo")}
              value={data.realDeliveryDateTo}
              onChange={(e: any) => {
                setData({
                  ...data,
                  realDeliveryDateTo: e,
                });
              }}
              mask={"__/__/____"}
              inputFormat={"DD/MM/YYYY"}
              renderInput={(params: any) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  error={false}
                />
              )}
            />
          </Box>

          <Box>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="keyless-label">{t("statusReport.filterAndSearch.keyless")}</InputLabel>
              <Select
                  labelId="keyless-label"
                  id="keyless-label"
                  value={data.keyless}
                  onChange={(event) => setData({...data, keyless: event.target.value})}
              >
                <MenuItem value={''}></MenuItem>
                <MenuItem value={0}>{t("vehicle.no")}</MenuItem>
                <MenuItem value={1}>{t("vehicle.yes")}</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </GenericFilterBox>
      </form>
    </Box>
  );
};
export default FiltersModal;
